import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import "rxjs/add/operator/map";

import { FarmDashboardPage } from '../farms/farmDashboard/farmDashboard';
import { ImcpaAppProvider } from '../../providers/imcpaApp/imcpaApp';
import { MysqlService } from '../../services/mysql.service';


// declare var google;
let map: any;

interface Track{
  region: string;
  team: string;
  incident_date: string;
}

@Component({
  selector: 'page-global',
  templateUrl: 'global.html',
  // styleUrls: [ 'global.scss', '../../theme/variables.scss' ]
})
export class GlobalPage {

    goshalas = [];
    public myreturnvalue;
    public loading;
    public stats = [];
    public stat: any = {};


  @ViewChild('map') mapElement: ElementRef;
  zoom: number = 1.5;
  
  // initial center position for the map
  lat: number = 23.4162;
  lng: number = 15.6628;

  tracker: string = "Infrigement";

  constructor(public navCtrl: NavController, public myApp: ImcpaAppProvider, public dbService: MysqlService, public loadingCtrl: LoadingController,) {

    // this.goshalas = this.imcpaAppProvider.getGoshalas();
    this.getGoshalas();
    // this.getStats();
  }
  async presentLoading() {
    this.loading = await this.loadingCtrl.create({
      content: 'Loading Data, please wait..',
    });
    return await this.loading.present();  
  }

    getGoshalas(){
    this.presentLoading()
    this.dbService.fetchDataV2("SELECT * from farms WHERE gpsLat IS NOT NULL and gpsLat != '0.000000' and id not in ( 0 )")
      .map(res => res.json())
      .subscribe(res => {
          // this.loading.dismiss();
        this.goshalas=res.data;
        console.log(this.goshalas)
        this.getStats();
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
  }

  getStats(){
    // this.presentLoading()
    this.dbService.fetchDataV2('SELECT * FROM dashboardFarms')
      .map(res => res.json())
      .subscribe(res => {
          this.loading.dismiss();
        this.stat=res.data[0];
        // this.getContinents();
        // console.log(this.goshalas);
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        // this.myreturnvalue = "Error : " + error;
        // console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
  }

  //     getStats(){
  //   this.dbService.fetchDataV2("SELECT count(*) as 'totalFarms' from farms f WHERE f.id NOT IN ( 0 )  union SELECT sum(totalCows) as 'totalCows' from farms where id NOT IN ( 0 ) union select sum(totalBulls) as 'totalBulls' from farms where id NOT IN ( 0 ) union SELECT COUNT(DISTINCT region) AS 'totalRegions' FROM farms where id NOT IN ( 0 );")
  //     .map(res => res.json())
  //     .subscribe(res => {
          
  //       this.stats=res.data;
  //       console.log(this.stats[0].totalFarms)
  //       this.loading.dismiss();
  //       }, error => {
  //       alert("FAILED, to fetch from php : "+ error);
  //       this.myreturnvalue = "Error : " + error;
  //       console.log(this.myreturnvalue)
  //       this.loading.dismiss();
  //     });
  // }

  onMouseOver(infoWindow, gm) {

    if(gm.lastOpen != null) {
      gm.lastOpen.close();
    }
    gm.lastOpen = infoWindow;
    infoWindow.open();

  }

  clickedMarker(g, i) {
      if(this.myApp.access.role === 'Admin'){
        this.navCtrl.push(FarmDashboardPage, {goshala: g}) 
      }
      // this.navCtrl.push(FarmDashboardPage, {goshala: g})
    // var clickOn = 
    // var goshalaData = this.goshalas.find(x=>x.name = label) 

    //   console.log(`clicked the marker: ${label || index}`)
  }
  
  
}

// ADDITIONAL FUNCTIONS THAT CAN BE USED ON THE MAP:

// mapClicked($event: MouseEvent) {
  //   this.markers.push({
  //     lat: $event.coords.lat,
  //     lng: $event.coords.lng,
  //     draggable: true
  //   });
  // }
  
  // markerDragEnd(m: marker, $event: MouseEvent) {
  //   console.log('dragEnd', m, $event);
  // }
  
  // markers: marker[] = [
	//   {
	// 	  lat: -28.356138,
	// 	  lng: 153.31907,
	// 	  label: 'New Govardhan Farm',
	// 	  // draggable: true
	//   },
  //   {
	// 	  lat: 40.494236,
	// 	  lng: -77.464173,
	// 	  label: 'Gita Nagari Farm',
	// 	  draggable: true
	//   },
  //   {
	// 	  lat: 51.665168, 
	// 	  lng: -0.338344,
	// 	  label: 'New Gokul Farm',
	// 	  draggable: true
	//   }
  // ]


// just an interface for type safety.
// interface marker {
// 	lat: number;
// 	lng: number;
// 	label?: string;
// 	draggable: boolean;
// }







// WEBPACK FOOTER //
// ./src/pages/global/global.ts